import { type ReactNode, useState } from "react";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { Box, Collapse, IconFa } from "@cruk/cruk-react-components";

import styles from "@fwa/src/components/CollapsableSection/styles.module.css";

export const CollapsableSection = ({
  id,
  headerTitleText,
  headerBody,
  headerIcon,
  startOpen = false,
  children,
  handleOpenChanged,
}: {
  id: string;
  headerTitleText: string;
  headerBody?: ReactNode;
  headerIcon?: ReactNode;
  startOpen?: boolean;
  handleOpenChanged?: (isOpen: boolean) => void;
  children: ReactNode;
}) => {
  const [settingsOpen, setSettingsOpen] = useState(startOpen);
  const handleSettingsOpen = (value: boolean) => {
    if (handleOpenChanged) {
      handleOpenChanged(value);
    }
    setSettingsOpen(value);
  };

  return (
    <Collapse
      id={id}
      headerComponent={
        headerIcon || headerBody ? (
          <Box>
            <div>
              {headerIcon ? (
                <Box as="span" paddingRight={headerIcon ? "xs" : "none"}>
                  {headerIcon}
                </Box>
              ) : null}
              <span className={styles["header-text"]}>{headerTitleText}</span>
              <span
                className={styles["flipping-icon"]}
                data-is-open={settingsOpen}
              >
                <IconFa faIcon={faChevronDown} />
              </span>
            </div>
            {headerBody}
          </Box>
        ) : null
      }
      headerTitleText={headerTitleText}
      startOpen={startOpen}
      headerTitleTextSize="l"
      headerTitleTextFontFamily="var(--font-family-headings,  Progress)"
      onOpenChange={handleSettingsOpen}
    >
      {children}
    </Collapse>
  );
};

export default CollapsableSection;
